import React, { createRef } from "react";
import useStyles from "./styles";
import CloseIcon from "@material-ui/icons/Close";
import theme from "theme";

import { Grid, Dialog, IconButton, Button } from "@material-ui/core";
import { Images } from "config/images";
import { formatCash } from "config/constant";

function HeaderDialog({ money, handleWatchOrder, getBanner, type }) {
	const classes = useStyles();
	return money !== 0 ? (
		<Grid classes={{ root: classes.headerSecond }}>
			<IconButton aria-label="close" onClick={handleWatchOrder}>
				<CloseIcon />
			</IconButton>
		</Grid>
	) : (
		<Grid classes={{ root: classes.header }}>
			{money === 0 && <img src={getBanner(type)} alt={type} />}
			<IconButton
				aria-label="close"
				onClick={handleWatchOrder}
				classes={{ root: classes.btnClose }}
			>
				<CloseIcon />
			</IconButton>
		</Grid>
	);
}

function BodyDialog({ money, open, type }) {
	const classes = useStyles();

	const getType = type => {
		switch (type) {
			case "BRONZE_1":
				return "Đồng";
			case "GOLD":
				return "Vàng";
			case "SILVER_1":
				return "Bạc";
			default:
				return "Đồng";
		}
	};

	return money !== 0 ? (
		<React.Fragment>
			<img
				src={!open.isError ? Images.icGiftSuccess : Images.icGiftError}
				alt={!open.isError ? "icGiftSuccess" : "icGiftError"}
				width={72}
			/>

			<Grid classes={{ root: classes.title }}>
				{!open.isError ? "Đặt hàng thành công" : "Đặt hàng thất bại"}
			</Grid>
			<Grid classes={{ root: classes.title }}>
				Bạn còn{" "}
				<span style={{ color: theme.palette.error.light }}>
					{formatCash(money)} Đ
				</span>{" "}
				để đạt hạng {getType(type)}
			</Grid>
		</React.Fragment>
	) : (
		<Grid>
			<Grid classes={{ root: classes.titleHappy }}>Chúc mừng</Grid>
			<Grid classes={{ root: classes.title }}>
				Bạn đã đạt hạng{" "}
				<span style={{ color: theme.palette.error.light }}>
					{getType(type)}
				</span>
			</Grid>
		</Grid>
	);
}

function FooterDialog({
	open,
	handleTryAgain,
	handleHome,
	handleWatchOrder,
	money
}) {
	const classes = useStyles();
	return open.isError ? (
		<React.Fragment>
			<Grid classes={{ root: classes.driver }} />
			<Grid
				classes={{ root: classes.btnSubmit }}
				onClick={() => handleTryAgain()}
			>
				Thử lại
			</Grid>
		</React.Fragment>
	) : (
		<Grid
			container
			spacing={1}
			classes={{ root: classes.bodyFooter }}
			justifyContent="center"
		>
			<Grid item xs={6}>
				<Button
					classes={{ root: classes.btnCancel }}
					onClick={() => handleHome()}
				>
					Trang chủ
				</Button>
			</Grid>
			{money !== 0 && (
				<Grid item xs={6}>
					<Button
						classes={{
							root: classes.btnConfirm
						}}
						onClick={() => handleWatchOrder()}
					>
						Xem đơn hàng
					</Button>
				</Grid>
			)}
		</Grid>
	);
}

const DialogInformation = props => {
	const classes = useStyles();
	const {
		handleWatchOrder,
		open,
		handleTryAgain,
		handleHome,
		type = "GOLD",
		money = 0
	} = props;
	const nodeRef = createRef();

	const getBanner = type => {
		switch (type) {
			case "BRONZE_1":
				return Images.bannerBronze;
			case "GOLD":
				return Images.bannerGold;
			case "SILVER_1":
				return Images.bannerSilver;
			default:
				return Images.bannerBronze;
		}
	};

	return (
		<Dialog
			onClose={() => handleWatchOrder()}
			aria-labelledby="customized-dialog-title"
			open={open.isOpen}
			ref={nodeRef}
			fullWidth
			classes={{
				paper:
					money !== 0
						? classes.customDialog
						: classes.customDialogSecond
			}}
		>
			<Grid style={{ position: "relative" }}>
				<HeaderDialog
					money={money}
					handleWatchOrder={handleWatchOrder}
					getBanner={getBanner}
					type={type}
				/>

				<Grid
					classes={{ root: classes.body }}
					style={{
						background:
							money !== 0
								? theme.palette.grey["A100"]
								: theme.palette.common.white
					}}
				>
					<BodyDialog money={money} open={open} type={type} />
					{open.message && (
						<Grid classes={{ root: classes.subTitle }}>
							{open.message}
						</Grid>
					)}
					<FooterDialog
						open={open}
						handleTryAgain={handleTryAgain}
						handleHome={handleHome}
						handleWatchOrder={handleWatchOrder}
						money={money}
					/>
				</Grid>
			</Grid>
		</Dialog>
	);
};

export default DialogInformation;
